import controller from './__init/controller';
import detectTabNav from './__utils/detectTabNav';
import throttle from 'lodash/throttle';

let handled = false;

controller.init();

window.addEventListener('load', controller.loaded);
window.addEventListener('scroll', throttle(controller.scrolled, 100), {
	passive: true,
});
window.addEventListener('resize', throttle(controller.resized, 100));
window.addEventListener('keydown', (e) => {
	detectTabNav(e);
	controller.keyDown(e);
});

const handleMouseAndTouchEvents = (e) => {
	if (e.type === 'touchend') {
		handled = true;
		controller.mouseUp(e);
	} else if (e.type === 'mouseup' && !handled) {
		controller.mouseUp(e);
	} else {
		handled = false;
	}
};

document.addEventListener('DOMContentLoaded', function () {
	// Replace 'your-search-input-id' with the actual ID of your search input field

	const locationsSearchInput = document.getElementById('wpsl-search-input');

	// Add placeholder text
	if (locationsSearchInput) {
		locationsSearchInput.placeholder = 'Enter City / Zip Code';

		// Optional: You can also clear the placeholder text when the user focuses on the input field
		locationsSearchInput.addEventListener('focus', function () {
			this.placeholder = '';
		});

		// Optional: Restore the placeholder text if the user leaves the input field without entering anything
		locationsSearchInput.addEventListener('blur', function () {
			this.placeholder = 'Enter City / Zip Code';
		});
	}
});

document.addEventListener('mouseup', handleMouseAndTouchEvents);
document.addEventListener('touchend', handleMouseAndTouchEvents);
